import type { FaireProductEntity } from "../../entity_types/product";

export const p_b77fdhuyjs: FaireProductEntity = {
  token: "p_b77fdhuyjs",
  type: "product",
  name: "Dainty Gold Black Star Layering Necklace, Gold Necklace, Layering Necklace, Star Necklace, Choker Necklace, Mom Christmas Gift, sku# Z712",
  brandToken: "b_4f46qpq5wu",
  brandName: "BestBeads&Beyond",
  imageUrl:
    "https://cdn.faire.com/fastly/2404e661c81efe346b3a040402e89918c4bbe3ec6d077f6427bf259a9e5f5483.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fa4b4afa6768038637b9f2a57564ed36313be941d09e1794e75534d62bede57e.jpeg",
    "https://cdn.faire.com/fastly/6eb5d45534b7cf10ae75218991954a1e3714b4d279e79248785cac6259bc995b.jpeg",
    "https://cdn.faire.com/fastly/a2a133857a5ffacd57978a1c920b3d542a45bd4569aa0577fd2cadc06bc4174e.jpeg",
    "https://cdn.faire.com/fastly/5f4659aeafad0888de4508ba0e16df31c7b11a3d77cdf28eeabe8b1f59661a53.jpeg",
  ],
  priceDollars: 15.32,
  description:
    '\nLength: 16" Long, AdjustableLength: 16"\n AdjustableNote: For Gemstone beads, the hole size is approximate. For smaller size beads e.g., 2mm, 3mm, hole size is less than 1mm.\n',
  tags: [],
  msrpDollars: 30.64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:58:57.399Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
